var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:`banner--${_vm.computedVariant}`},[_c('div',{staticClass:"banner__text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.textHTML)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }